import React from 'react';
import { branch, renderComponent } from 'recompose';

import Money from '../../../../../common/money';
import { t } from '../../../../../../modules/infra/i18n';

const ValueLoyalty = ({ survivingCustomer, duplicates, duplicateCellClass }) => (
  <div className="c-table-card__row">
    <div className="c-table-card__cell u-2/12">
      <div>{t('customers:duplicates.loyalty_money_amount')}</div>
    </div>
    <div className="c-table-card__cell u-3/12 u-pv">
      <div className="u-type--semibold">
        <Money>{survivingCustomer.loyaltyRewardCounter}</Money>
      </div>
    </div>
    {
      duplicates.map((d, idx) => (
        <div key={idx} className={duplicateCellClass}>
          <div className="u-type--semibold">
            <Money>{d.loyaltyRewardCounter}</Money>
          </div>
        </div>
      ))
    }
  </div>
);

const TransactionLoyalty = ({ survivingCustomer, duplicates, duplicateCellClass }) => (
  <div className="c-table-card__row">
    <div className="c-table-card__cell u-2/12">
      <div>{t('customers:duplicates.loyalty_counter')}</div>
    </div>
    <div className="c-table-card__cell u-3/12 u-pv">
      <div className="u-type--semibold">
        {survivingCustomer.loyaltyRewardCounter} {t('customers:duplicates.appointments_text')}
      </div>
      <div className="u-type--semibold" display-if={survivingCustomer.loyaltyReward}>
        {t('customers:duplicates.loyalty_reward_message', { amount: `$${survivingCustomer.loyaltyReward}` })}
      </div>
    </div>
    {
      duplicates.map((d, idx) => (
        <div key={idx} className={duplicateCellClass}>
          <div className="u-type--semibold">
            {d.loyaltyRewardCounter} {t('customers:duplicates.appointments_text')}
          </div>
        </div>
      ))
    }
  </div>
);

export default branch(
  props => props.survivingCustomer.loyaltyRewardType === 'transaction',
  renderComponent(TransactionLoyalty),
)(ValueLoyalty);
